import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'

import { FORM_CUBICAJE_SILOS } from '../../../config/forms'
import { OperacionesAltaCubicajeSiloDialogView } from '../components/OperacionesAltaCubicajeSiloDialogView'

class OperacionesAltaCubicajeSiloDialog extends Component {
  render () {
    const { silo } = this.props
    return (
      <OperacionesAltaCubicajeSiloDialogView
        silo={silo}
      />
    )
  }
}

const mapStateToProps = state => {
  return {
    silo: state.movimientoSilos.siloOperando
  }
}
export default reduxForm({
  form: FORM_CUBICAJE_SILOS,
  initialValues: { },
  enableReinitialize: true
})(connect(mapStateToProps)(OperacionesAltaCubicajeSiloDialog))
